"use strict";

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_rxzvo5yat = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/crud/RepositoryQuickCreate.js";
  var hash = "3f2cbc864daafce511262c2121f15d6050102515";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/crud/RepositoryQuickCreate.js",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 18
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "1": {
        start: {
          line: 17,
          column: 39
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "2": {
        start: {
          line: 41,
          column: 18
        },
        end: {
          line: 41,
          column: 29
        }
      },
      "3": {
        start: {
          line: 42,
          column: 26
        },
        end: {
          line: 42,
          column: 36
        }
      },
      "4": {
        start: {
          line: 43,
          column: 36
        },
        end: {
          line: 43,
          column: 69
        }
      },
      "5": {
        start: {
          line: 44,
          column: 34
        },
        end: {
          line: 44,
          column: 63
        }
      },
      "6": {
        start: {
          line: 46,
          column: 45
        },
        end: {
          line: 46,
          column: 59
        }
      },
      "7": {
        start: {
          line: 48,
          column: 23
        },
        end: {
          line: 50,
          column: 20
        }
      },
      "8": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 27
        }
      },
      "9": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 93,
          column: 4
        }
      },
      "10": {
        start: {
          line: 79,
          column: 14
        },
        end: {
          line: 79,
          column: 42
        }
      },
      "11": {
        start: {
          line: 96,
          column: 0
        },
        end: {
          line: 96,
          column: 37
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 29
          },
          end: {
            line: 17,
            column: 30
          }
        },
        loc: {
          start: {
            line: 17,
            column: 39
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "RepositoryQuickCreate",
        decl: {
          start: {
            line: 40,
            column: 9
          },
          end: {
            line: 40,
            column: 30
          }
        },
        loc: {
          start: {
            line: 40,
            column: 33
          },
          end: {
            line: 94,
            column: 1
          }
        },
        line: 40
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 48,
            column: 35
          },
          end: {
            line: 48,
            column: 36
          }
        },
        loc: {
          start: {
            line: 48,
            column: 41
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 48
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 78,
            column: 22
          },
          end: {
            line: 78,
            column: 23
          }
        },
        loc: {
          start: {
            line: 78,
            column: 33
          },
          end: {
            line: 80,
            column: 13
          }
        },
        line: 78
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "3f2cbc864daafce511262c2121f15d6050102515"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _ = require("../..");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var useStyles = (cov_rxzvo5yat.s[0]++, (0, _styles.makeStyles)(function (theme) {
  cov_rxzvo5yat.f[0]++;
  cov_rxzvo5yat.s[1]++;
  return {
    listItemAvatar: {
      marginRight: '16px',
      marginTop: '20px'
    },
    avatar: {
      borderRadius: '20%'
    },
    root: {
      borderRadius: theme.shape.borderRadius,
      marginLeft: 0,
      width: '100%'
    },
    form: {
      width: '100%'
    },
    input: {
      width: '40%',
      display: 'inline-block',
      marginRight: '1em'
    }
  };
}));

function RepositoryQuickCreate() {
  cov_rxzvo5yat.f[1]++;
  var classes = (cov_rxzvo5yat.s[2]++, useStyles());

  var _ref = (cov_rxzvo5yat.s[3]++, (0, _react.useState)()),
      _ref2 = _slicedToArray(_ref, 2),
      repo = _ref2[0],
      setRepo = _ref2[1];

  var _ref3 = (cov_rxzvo5yat.s[4]++, (0, _react.useContext)(_.AuthenticationContext)),
      authentication = _ref3.state;

  var _ref4 = (cov_rxzvo5yat.s[5]++, (0, _react.useContext)(_.RepositoryContext)),
      create = _ref4.actions.create;

  var _ref5 = (cov_rxzvo5yat.s[6]++, authentication),
      _ref5$user = _ref5.user,
      username = _ref5$user.username,
      avatar_url = _ref5$user.avatar_url;

  var handleCreate = (cov_rxzvo5yat.s[7]++, (0, _react.useCallback)(function () {
    cov_rxzvo5yat.f[2]++;
    cov_rxzvo5yat.s[8]++;
    create({
      name: repo
    });
  }, [repo, create]));
  cov_rxzvo5yat.s[9]++;
  return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    alignItems: "flex-start",
    ContainerComponent: "div",
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemAvatar, {
    className: classes.listItemAvatar
  }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    alt: username,
    src: avatar_url,
    className: classes.avatar
  })), /*#__PURE__*/_react.default.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.input
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    id: "owner",
    label: "Owner",
    type: "text",
    disabled: true,
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    defaultValue: username
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.input
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    id: "repo",
    label: "Repository",
    type: "text",
    required: true,
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    defaultValue: "",
    autoComplete: undefined,
    onChange: function onChange(event) {
      cov_rxzvo5yat.f[3]++;
      cov_rxzvo5yat.s[10]++;
      setRepo(event.target.value);
    }
  }))), /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-label": "Add Repo",
    onClick: handleCreate
  }, /*#__PURE__*/_react.default.createElement(_icons.AddCircle, null))));
}

cov_rxzvo5yat.s[11]++;
RepositoryQuickCreate.propTypes = {};
var _default = RepositoryQuickCreate;
exports.default = _default;